const ClientNameCell = ({
    caseData
}) => {

    return (
        <>
            {caseData.clients?.map((c, i) => (
                <div key={i}>{c.personalInfo.clientName}</div>
            ))}
        </>
    );
};

export default ClientNameCell;